import { Paper, Stack, styled } from "@/components";

const StyledStack = styled(Stack)(({ theme }) => ({
  display: "inline-flex",
  flexDirection: "row",
  padding: theme.spacing(1),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  padding: theme.spacing(1.5),
  paddingRight: theme.spacing(5),
  backgroundColor: theme.palette.gray2?.main || "#e4e8e9",
  borderRadius: 12,
  boxShadow:
    "0 1px 2px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.08)",
  "&::after": {
    content: '""',
    position: "absolute",
    left: theme.spacing(3),
    bottom: -8,
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: `8px solid ${theme.palette.gray2?.main || "#e4e8e9"}`,
  },
}));

const StyledInputRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  backgroundColor: theme.palette.common.white,
  borderRadius: 8,
  padding: theme.spacing(0.5, 0.75),
  border: `1px solid ${theme.palette.gray1?.main || "#caced8"}`,
}));

const StyledInput = styled("input")(({ theme }) => ({
  all: "unset",
  flex: 1,
  color: theme.palette.text.primary,
  fontSize: 14,
  lineHeight: 1.5,
  padding: theme.spacing(0.5, 0.25),
}));

export { StyledStack, StyledPaper, StyledInputRow, StyledInput };
